var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("" + (_vm.iframe ? 'vuep-iframe' : ''))},[_c('vuep',{attrs:{"value":_vm.template,"options":{ theme: 'vueds' },"iframe":_vm.iframe}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }